import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';

function LoadingModal({ show }) {
    {
        if (show) {
            return (
                <>
                    <div className="modal-semi-transparent">
                    {/*this div displays semi transparent background*/}
                    </div>
                    <div>
                        <Spinner className="spinner loading-modal-spinner" animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                </>
                
            )
        }
    }
}

export default LoadingModal;